import { SEARCH_LIST_API_PREFIX } from '@aibees/elephant/constants';
import {
  CreateSearchListRequest,
  SearchList,
} from '@aibees/elephant/hooks/search-list/types';
import { HttpMethod } from '@aibees/shared/definition';
import { useBaseMutation } from '@aibees/shared/http';
import { useWorkspace } from '@aibees/shared/workspace';

export function useCreateSearchList() {
  const workspaceId = useWorkspace()?.id;

  return useBaseMutation<CreateSearchListRequest, SearchList>(
    {
      url: SEARCH_LIST_API_PREFIX.replace(':wid', String(workspaceId)),
      method: HttpMethod.post,
    },
    {
      onSuccess() {
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        // invalidateDebounced();
      },
    }
  );
}
